import React from 'react';

const DEFAULT_BUCKET_URL = 'https://cipa-website-forms.s3.us-east-2.amazonaws.com';

// Default items match the original newborn first-visit forms,
// so existing usages keep working without any changes.
const DEFAULT_ITEMS = [
  { label: 'New patient registration',    link: `${DEFAULT_BUCKET_URL}/newpatient_registration.pdf` },
  { label: 'Newborn Questionnaire',          link: `${DEFAULT_BUCKET_URL}/newborn_patient_questionnaire.pdf` },
  { label: 'Privacy policy and consent',      link: `${DEFAULT_BUCKET_URL}/noticeforprivacypractices.pdf` },
];

const PatientFormsList = ({
  items              = DEFAULT_ITEMS,
  heading            = 'Kindly download these forms before your first visit',
  allFormsLink       = '/patient-center/patient-forms',
  allFormsLinkLabel  = 'View all patient forms',
}) => {
  return (
    <div className="my-2 rounded-lg bg-white shadow-sm">
      <h4 className="text-l text-gray-800 mb-2">
        {heading}
      </h4>

      <ul className="list-disc list-outside ml-5 space-y-2 text-gray-700">
        {items.map((item) => (
          <li key={item.label}>
            <a
              href={item.link}
              className="text-blue-600 underline hover:text-blue-800"
              target="_blank"
              rel="noopener noreferrer"
            >
              {item.label}
            </a>
          </li>
        ))}
      </ul>

      <div className="mt-4">
        <a
          href={allFormsLink}
          className="inline-block rounded-md bg-custom-blue px-4 py-2 text-white hover:opacity-90"
        >
          {allFormsLinkLabel}
        </a>
      </div>
    </div>
  );
};

export default PatientFormsList;